import { useLanguage } from '../../../../features/language/useLanguage';

type BadgeKind = 'order' | 'payment' | 'delivery';

const BADGE_CLASS: Record<BadgeKind, (status: string) => string> = {
  order: (status) =>
    status === 'draft'
      ? 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/20'
      : status === 'ordered'
        ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20'
        : status === 'cancelled'
          ? 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20'
          : 'bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-600/20',
  payment: (status) =>
    status === 'paid'
      ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20'
      : status === 'refunded'
        ? 'bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-600/20'
        : 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20',
  delivery: (status) =>
    status === 'received'
      ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20'
      : status === 'shipping'
        ? 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/20'
        : 'bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-600/20',
};

const DOT_CLASS: Record<BadgeKind, (status: string) => string> = {
  order: (status) =>
    status === 'draft' ? 'bg-blue-500' : status === 'ordered' ? 'bg-green-500' : status === 'cancelled' ? 'bg-red-500' : 'bg-gray-400',
  payment: (status) => (status === 'paid' ? 'bg-green-500' : status === 'refunded' ? 'bg-gray-400' : 'bg-red-500'),
  delivery: (status) => (status === 'received' ? 'bg-green-500' : status === 'shipping' ? 'bg-blue-500' : 'bg-gray-400'),
};

/** Status pill (with colored dot) for a purchase order's order/payment/delivery status. */
export function POStatusBadge({ kind, status }: { kind: BadgeKind; status: string }) {
  const { t } = useLanguage();
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${BADGE_CLASS[kind](status)}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${DOT_CLASS[kind](status)}`} />
      {t(`purchaseOrder.filters.options.${status}`, undefined, status)}
    </span>
  );
}
